const THERE_WAS_AN_ERROR = 'There was an error';
export const COURSE = {
  coursesErrorMessage: `${THERE_WAS_AN_ERROR} fetching all courses`,
  courseByIdErrorMessage: `${THERE_WAS_AN_ERROR} fetching course by ID`,
  saveCourseSuccessMessage: `Course Saved`,
  saveCourseErrorMessage: `${THERE_WAS_AN_ERROR} saving a course`,
  deleteCourseErrorMessage: `${THERE_WAS_AN_ERROR} deleting a course`,
  deleteCourseSuccessMessage: `Unsaved`,
};

export const ENROLL_COURSE_PATH = 'enrollCoursePath';

export enum TimezoneDisplay {
  'America/Anchorage' = 'Alaska Time',
  'America/Phoenix' = 'Mountain Standard Time',
  'America/Chicago' = 'Central Time',
  'America/New_York' = 'Eastern Time',
  'Pacific/Honolulu' = 'Hawaii Standard Time',
  'America/Denver' = 'Mountain Time',
  'America/Los_Angeles' = 'Pacific Time',
}

export const SUPPORTED_TIMEZONES = Object.keys(TimezoneDisplay) as (keyof typeof TimezoneDisplay)[];

export function getFriendlyTimezoneName(ianaTimezone: string): string {
  return TimezoneDisplay[ianaTimezone as keyof typeof TimezoneDisplay] || ianaTimezone;
}

export const DAYS_OF_WEEK_OPTIONS = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' },
];
